import React from "react";
import "./cta.css";

const CTA = () => {
  return (
    <div className="cta-container" id="contact">
      <div className="cta-left">
        <div className="cta-mainText">
          <p>Ready to be Second-to-none?</p>
        </div>
        <div className="cta-subText">
          Qevolt is the simple way to get it done. Create an account and get
          started for free
        </div>
      </div>
      <div className="cta-right">
        <a
          href="https://app.qevolt.com/account/signup"
          target = "_blank"
          className="cta-button button-anim"
        >
          Create an account
        </a>
      </div>
    </div>
  );
};

export default CTA;
